import "./Pages.css";
import CountyCard from "../components/CountyCard.js";
import CustomPagination from "../components/Pagination.js";
import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";

export default function CountiesPage() {
  const [selected, setSelected] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(56);
  const [instanceCount, setInstanceCount] = React.useState([0, 0]);
  const [cardData, setCardData] = React.useState(null);
  const [sortBy, setSortBy] = React.useState("name");
  const [order, setOrder] = React.useState("asc");
  const [minPopulation, setMinPopulation] = React.useState(null);
  const [unemployment, setUnemployment] = React.useState(null);
  const [minIncome, setMinIncome] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState();
  const [tempSearchTerm, setTempSearchTerm] = React.useState();

  function onPageChange(value) {
    setSelected(value);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${
            process.env.REACT_APP_FLASK_URL
          }/texascounties?page=${selected}&sort_by=${sortBy}&order=${order}&min_population=${minPopulation}&unemployment=${unemployment}&min_income=${minIncome}${
            searchTerm ? `&term=${searchTerm}` : ""
          }`
        );
        const data = await response.json();
        setInstanceCount([data.total, data?.counties.length]);
        setCardData(data.counties);
        setTotalPages(data.pages);
      } catch (error) {
        console.error("Error fetching rows:", error);
      }
    };

    fetchData();
  }, [
    selected,
    sortBy,
    order,
    minPopulation,
    unemployment,
    minIncome,
    searchTerm,
  ]);

  const handleSortChange = (newSortBy) => {
    if (sortBy === newSortBy) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setSortBy(newSortBy);
      setOrder("asc");
    }
    setSelected(1);
  };

  return (
    <>
      <div>
        <h1 id="texas-counties">Texas Counties</h1>
      </div>
      <div className="container">
        <div className="container d-flex flex-wrap gap-1 justify-content-end mx-auto w-100 mt-3">
          <InputGroup id="search">
            <Form.Control
              size="lg"
              type="text"
              placeholder="Search Counties"
              onChange={(e) => setTempSearchTerm(e.target.value)}
            />
            <Button
              variant="primary"
              onClick={() => setSearchTerm(tempSearchTerm)}
            >
              Search
            </Button>
          </InputGroup>
        </div>
        <div className="container d-flex flex-wrap gap-1 justify-content-end mx-auto">
          <button
            onClick={() => handleSortChange("name")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by Name{" "}
            {sortBy === "name" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
          <button
            onClick={() => handleSortChange("population")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by Population{" "}
            {sortBy === "population" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
          <button
            onClick={() => handleSortChange("income")}
            className="btn btn-outline-primary mx-1"
          >
            Sort by Income{" "}
            {sortBy === "income" ? (order === "asc" ? "↑" : "↓") : ""}
          </button>
        </div>
        <div className="container d-flex flex-wrap gap-3 justify-content-end mx-auto">
          <Form.Select
            aria-label="Select Population"
            className="w-auto"
            onChange={(e) => setMinPopulation(e.target.value)}
          >
            <option value="null">Select Population</option>
            <option value="0-25000">Population: 0-25000</option>
            <option value="25000-50000">Population: 25000-50000</option>
            <option value="50000-75000">Population: 50000-75000</option>
            <option value="75000-100000">Population: 75000-100000</option>
            <option value="100000-300000">Population: 100000-300000</option>
            <option value="300000-1000000">Population: 300000-1000000</option>
          </Form.Select>
          <Form.Select
            aria-label="Select Income"
            className="w-auto"
            onChange={(e) => setMinIncome(e.target.value)}
          >
            <option value="null">Select Median Income</option>
            <option value="0-50000">Median Income: 0-50000</option>
            <option value="50000-60000">Median Income: 50000-60000</option>
            <option value="60000-80000">Median Income: 60000-80000</option>
            <option value="80000-100000">Median Income: 80000-100000</option>
            <option value="100000-120000">Median Income: 100000-120000</option>
          </Form.Select>
          <Form.Select
            aria-label="Select Unemployment Range"
            className="w-auto"
            onChange={(e) => setUnemployment(e.target.value)}
          >
            <option value="null">Select Unemployment Range</option>
            <option value="0-20000">Unemployment: 0-20000</option>
            <option value="20000-50000">Unemployment: 20000-50000</option>
            <option value="50000-70000">Unemployment: 50000-70000</option>
          </Form.Select>
        </div>
      </div>
      {cardData === null && (
        <div className="container d-flex flex-wrap gap-3 justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <div className="container d-flex flex-column align-items-center">
        <div className="d-flex flex-wrap gap-3 justify-content-center">
          {cardData?.map((county, index) => (
            <CountyCard
              key={index}
              county={county}
              searchTerm={searchTerm}
            ></CountyCard>
          ))}
        </div>
        <CustomPagination
          last={totalPages}
          selected={selected}
          onPageChange={onPageChange}
          total={instanceCount[0]}
          current={instanceCount[1]}
        ></CustomPagination>
      </div>
    </>
  );
}
